import { updateObjectByPath, getPartOfStateValues } from "./utils";
import { File as FileI, Files } from "../interfaces/File";
import { State as FormStateCustom } from "../interfaces/Form/CustomForm";
import { FormState } from "../interfaces/Form/State";

export const stateAddFiles = <T extends FormState | FormStateCustom>(
  state: T,
  id: string,
  files: Files
) => {
  const prevFiles = getPartOfStateValues(state.values, id) || {};
  return {
    ...state,
    errors: updateObjectByPath(state.errors, id, ""),
    values: updateObjectByPath(state.values, id, {
      ...prevFiles,
      ...files
    })
  };
};

export const stateSetUploadedFile = <T extends FormState | FormStateCustom>(
  state: T,
  id: string,
  file: FileI
) => {
  const files = { ...getPartOfStateValues(state.values, id) } || {};
  //remove the previous record that was indexed by file name and set it by its id
  delete files[file.name];
  files[file.id] = file;
  return {
    ...state,
    values: updateObjectByPath(state.values, id, files)
  };
};

export const stateSetFilesError = <T extends FormState | FormStateCustom>(
  state: T,
  id: string,
  error?: string
) => {
  return {
    ...state,
    errors: updateObjectByPath(state.errors, id, error),
    values: updateObjectByPath(state.values, id, undefined)
  };
};

export const stateRemoveFile = <T extends FormState | FormStateCustom>(
  state: T,
  id: string,
  fileID: string
) => {
  const files = { ...getPartOfStateValues(state.values, id) };
  delete files[fileID];
  return {
    ...state,
    values: updateObjectByPath(state.values, id, files)
  };
};
